<script setup>
import { ref, watch, onMounted, computed } from 'vue'
import _ from 'lodash'
import { useDestinationStore } from '../../../store/destinationStore'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n/dist/vue-i18n'

const store = useStore()

const { t } = useI18n({ useScope: 'global' })

const destinationStore = useDestinationStore()

const selectedDestinationName = ref('')
const isSearching = ref(false)

watch(destinationStore.getSelectedDestinations, (newVal) => {
    if (newVal?.length) {
        selectedDestinationName.value = newVal[0].name
    }
})

// const orderData = computed(() => store.getters['purchase/getOrderData'])
// const activeOrderDataIndex = computed(() => store.getters['purchase/getActiveOrderDataIndex'])

onMounted(() => {
    const selectedDestinations = destinationStore.getSelectedDestinations;
    if (selectedDestinations?.length && selectedDestinations[0].id) {
        selectedDestinationName.value = selectedDestinations[0].name
    }
})

const handleFocus = _.debounce((value) => {
    isSearching.value = value
}, 100)

const handleInput = _.debounce((value) => {
    searchDestination(value)
}, 300)

async function searchDestination(query) {
    await destinationStore.fetchDestinations({
        query: query,
        limit: 10,
    });
}

function selectDestination(destination) {
    if (destination) {
        selectedDestinationName.value = destination.name
        // сохраняем в хранилище или событие
        destinationStore.setSelectedDestinationByIndex({
            "destination": destination,
            "index": 0
        })
    }
}
</script>

<template>
    <div class="purchase-rent-search">
        <div class="purchase-rent-search__title">
            <h1>{{ $t('purchase-rent-page.search.title') }}</h1>
            <h5>{{ $t('purchase-rent-page.search.subtitle') }}</h5>
        </div>

        <div class="purchase-rent-search__form">
            <div class="purchase-rent-search__form--bar">
                <div class="purchase-rent-search__form--bar-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#FF8818"><path d="M792-120.67 532.67-380q-30 25.33-69.64 39.67Q423.39-326 378.67-326q-108.44 0-183.56-75.17Q120-476.33 120-583.33t75.17-182.17q75.16-75.17 182.5-75.17 107.33 0 182.16 75.17 74.84 75.17 74.84 182.27 0 43.23-14 82.9-14 39.66-40.67 73l260 258.66-48 48Zm-414-272q79.17 0 134.58-55.83Q568-504.33 568-583.33q0-79-55.42-134.84Q457.17-774 378-774q-79.72 0-135.53 55.83-55.8 55.84-55.8 134.84t55.8 134.83q55.81 55.83 135.53 55.83Z"/></svg>
                </div>
                <div class="purchase-rent-search__form--bar-input">
                    <input v-model="selectedDestinationName" type="text"
                        :placeholder="$t('purchase-rent-page.search.placeholder')" aria-label="Search destinations"
                        @input="handleInput($event.target.value)" @focus="handleFocus(true)"
                        @blur="handleFocus(false)" />
                </div>
            </div>

            <div v-if="isSearching" class="purchase-rent-search__form--menu">
                <div class="purchase-rent-search__form--menu-items">
                    <div v-if="destinationStore.getDestinations.length" v-for="destination in destinationStore.getDestinations" :key="destination.id"
                        class="purchase-rent-search__form--menu-item" @click="selectDestination(destination)">
                        {{ destination.name }}
                    </div>
                    <h5 v-if="!destinationStore.getDestinations.length">{{ $t('purchase-rent-page.search.searching') }}</h5>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.purchase-rent-search {
    position: relative;
    margin-top: 2rem;

    &__title {
        margin-bottom: 1.5rem;

        h1 {
            text-align: center;
            font-size: 24px;
            font-weight: 400;
            margin-bottom: .5rem;
        }

        h5 {
            text-align: center;
            font-size: 16px;
            font-weight: 300;
        }
    }

    &__form {
        position: relative;

        &--bar {
            display: flex;
            height: 68px;
            width: 100%;
            border: 2px solid #FF8818;
            border-radius: .5rem;
            background: #ffffff;
        }

        &--bar-icon {
            width: 80px;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        &--bar-input {
            width: 100%;
            padding: 0 .5rem 0 0;

            input {
                box-sizing: border-box;
                width: 100%;
                height: 100%;
                font-size: 20px;

                &:focus {
                    border: none;
                    outline: none;
                }
            }
        }

        &--menu {
            width: 100%;
            min-height: 56px;
            background: #ffffff;
            border: 2px solid #FF8818;
            border-bottom-left-radius: .5rem;
            border-bottom-right-radius: .5rem;
            border-top: none;
            position: absolute;
            top: 60px;
            padding: .5rem 0;
            z-index: 100;
        }

        &--menu-items {
            h5 {
                margin: .5rem 1.5rem;
            }
        }

        &--menu-item {
            padding: .5rem 1.5rem;
            cursor: pointer;

            &:hover {
                background: #7DD3FC;
                color: #fff;
            }
        }
    }

    @media (max-width: 768px) {
        .purchase-rent-search__title h1 {
            font-size: 18px;
        }

        .purchase-rent-search__form--bar {
            height: 56px;
        }

        .purchase-rent-search__form--bar-input input {
            font-size: 16px;
        }

        .purchase-rent-search__form--menu {
            top: 48px;
        }
    }
}
</style>